//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
import dayjs from "dayjs";
import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router";
import { LOCATIONS } from "../../utils/global_variables";

const MfTable = ({ trayExpanded, mfData }) => {
    const location = useLocation()
    return (
        <Container fluid className='p-0'>
            <Row className='g-0 my-3'>
                <Col>
                    <div className='font-regular font-size2 color-subtext px-2'>*All values are in Crores</div>
                </Col>
            </Row>
            <div className={`${location.pathname === LOCATIONS.DASHBOARD ? "scanners-table-container pe-1" : trayExpanded ? 'scanners-side-tray-table-expand-container' : 'scanners-side-tray-table-container'}`}>
                {mfData?.length > 0 && mfData?.map(data => (
                    <div className='table-responsive mb-2'>
                        <table className='table table-hover table-striped scanners-table bdr'>
                            <thead>
                                <tr>
                                    {[data?.TransactionDate, 'Gross Purchase', 'Gross Sales', 'Net Purchase Sales']?.map((element, i) =>
                                        <th className='font-regular font-size1 table-th-color-text text-center col-3 text-truncate bdr-rgt'>
                                            {element === data?.TransactionDate ? dayjs(element)?.format('DD MMM \'YY') : element}
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>Equity</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.EquityGrossPurchase}</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.EquityGrossSale}</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.EquityNetPurchaseSales}</td>
                                </tr>
                                <tr>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>Debt</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.DebtGrossPurchase}</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.DebtGrossSales}</td>
                                    <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-3 bdr-rgt'>{data?.DebtNetPurchaseSales}</td>
                                </tr>
                            </tbody>
                        </table>                 
                    </div>
                ))
                }
            </div>
        </Container>
    );
};


export default memo(MfTable);
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End